<template>
  <div>
    <v-card v-if="!loading" class="pa-7 transition" color="gray10">
      <template v-if="!showSlider">
        <p class="text-center font-Regular-16">
          {{
            $t(
              "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.description"
            )
          }}
        </p>
        <v-alert
          text
          class=" px-3 py-3"
          color="warning"
          icon="$warning"
          rounded="lg"
        >
          <span class="font-Regular-16">
            {{
              $t(
                "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.warning"
              )
            }}
          </span>
        </v-alert>

        <div class="qr">
          <v-img :src="qrCode"></v-img>
        </div>

        <div class="mt-10 secret-code">
          <v-btn icon v-clipboard:copy="secretCode" v-clipboard:success="copy">
            <v-icon>$copy</v-icon>
          </v-btn>
          <span>{{ secretCode }}</span>
        </div>
      </template>
      <template v-else>
        <div class="guide-slider-content">
          <span class="font-Medium-16">{{
            $t(
              "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.guidSlider.title"
            )
          }}</span>

          <p class="text-center mt-5" style="min-height: 50px;">
            {{ slides[activeSlideIndex].description }}
          </p>
          <v-sheet max-width="300" class="mt-5" color="transparent">
            <swiper
              :options="swiperOption"
              ref="guideSwiper"
              @slideChange="onSlideChange"
            >
              <swiper-slide v-for="(slide, index) in slides" :key="index">
                <div class="d-flex ">
                  <img
                    :src="$vuetify.theme.dark ? slide.imgDark : slide.img"
                    alt=""
                    width="200"
                    class="mx-auto"
                  />
                </div>
              </swiper-slide>
              <div
                class="swiper-pagination guide-slider-pagination"
                slot="pagination"
              ></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>

            <div class="swiper-pagination guide-pagination"></div>
          </v-sheet>
        </div>
      </template>
    </v-card>

    <v-btn block color="primary" class="mt-15 py-6" @click="nextStep">
      {{
        $t("accountPage.security.twoFactorAuth.modals.activeGoogle.continue")
      }}
    </v-btn>
  </div>
</template>
<script>
import { OtpService } from "@/services";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  components: { swiper, swiperSlide },

  data() {
    return {
      loading: true,
      qrCode: null,
      secretCode: null,
      showSlider: false,
      swiperOption: {
        lazy: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "custom"
        },
        pagination: {
          el: ".guide-pagination",
          clickable: true,
          type: "bullets"
        }
      },
      slides: [
        {
          img: require("@/assets/image/donwloadLinksIcons/googleAuth/step1.png"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/step1-dark.png"),
          description: this.$t(
            "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.guidSlider.desc1"
          )
        },
        {
          img: require("@/assets/image/donwloadLinksIcons/googleAuth/step2.png"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/step2-dark.png"),
          description: this.$t(
            "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.guidSlider.desc2"
          )
        },
        {
          img: require("@/assets/image/donwloadLinksIcons/googleAuth/step3.png"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/step3-dark.png"),
          description: this.$t(
            "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.guidSlider.desc3"
          )
        },
        {
          img: require("@/assets/image/donwloadLinksIcons/googleAuth/step4.png"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/step4-dark.png"),
          description: this.$t(
            "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.guidSlider.desc4"
          )
        },
        {
          img: require("@/assets/image/donwloadLinksIcons/googleAuth/step5.png"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/step5-dark.png"),
          description: this.$t(
            "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.guidSlider.desc5"
          )
        }
      ],
      activeSlideIndex: 0
    };
  },

  methods: {
    onSlideChange() {
      this.activeSlideIndex = this.$refs.guideSwiper.swiper.realIndex;
    },
    async getQrCode() {
      OtpService.activeGoogle()
        .then(res => {
          this.qrCode = res.data.data.qrcode;
          this.secretCode = res.data.data.secret;
        })
        .finally(() => (this.loading = false));
    },
    copy() {
      this.$toast.success(
        this.$t(
          "accountPage.security.twoFactorAuth.modals.activeGoogle.step2.copy"
        )
      );
    },
    nextStep() {
      if (!this.showSlider) {
        this.showSlider = true;
      } else {
        // console.log(this.$refs.guideSwiper.swiper.slideNext());
        if (this.$refs.guideSwiper.swiper.isEnd) {
          this.$emit("nextStep");
        } else {
          this.$refs.guideSwiper.swiper.slideNext();
        }
      }
    }
  },

  async mounted() {
    await this.getQrCode();
  }
};
</script>

<style lang="scss">
.qr {
  margin: 0 auto;
  width: 170px;
  height: 170px;
}

.secret-code {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 16px;
  border: 1px solid var(--v-gray5-base);
  border-radius: 16px;
  max-width: 300px;
  margin: 0 auto;
}

.guide-slider-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.swiper-button-prev,
.swiper-button-next {
  width: 7px !important;
  height: 24px !important;
  background-size: 7px 24px !important;
}

.guide-pagination {
  position: relative !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  span {
    margin: 3px !important;
  }
}
</style>
